import { Message } from '@app/shared/models/app.model';
import { TranscriptUpdatePayload } from './transcript.types';

/**
 * Maps a `transcript.update` payload to the frontend `Message` shape so it can
 * flow through the existing (Firestore-shaped) rendering pipeline unchanged.
 * The only structural differences from the wire payload are `id -> documentID`
 * and the RFC3339 date strings becoming `Date` objects.
 */
export function mapTranscriptPayloadToMessage(p: TranscriptUpdatePayload): Message {
  return {
    documentID: p.id,
    is_final: p.is_final,
    confidence: p.confidence,
    language: p.language,
    message: p.message,
    transcripts: p.transcripts ?? {},
    micId: p.micId,
    micColor: p.micColor,
    speaker: p.speaker,
    created_at: new Date(p.created_at),
    updated_at: new Date(p.updated_at ?? p.created_at),
    timestamp: p.timestamp,
  };
}
